const REFERRAL_STORAGE_KEY = 'nocal_referral_context'

export interface ReferralContext {
  code: string
  clickedAt: string
}

function getCookie(name: string): string | null {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) return parts.pop()?.split(';').shift() || null
  return null
}

function setCookie(name: string, value: string, maxAgeSeconds: number) {
  document.cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=${maxAgeSeconds}; samesite=lax`
}

export function saveReferralContext(code: string) {
  const payload: ReferralContext = {
    code,
    clickedAt: new Date().toISOString()
  }
  localStorage.setItem(REFERRAL_STORAGE_KEY, JSON.stringify(payload))
  setCookie('nocal_ref_code', code, 60 * 60 * 24 * 30)
}

export function getReferralContext(): ReferralContext | null {
  const raw = localStorage.getItem(REFERRAL_STORAGE_KEY)
  if (raw) {
    try {
      const parsed = JSON.parse(raw) as ReferralContext
      if (parsed.code) return parsed
    } catch {
      // no-op
    }
  }

  const cookieCode = getCookie('nocal_ref_code')
  if (cookieCode) {
    return {
      code: decodeURIComponent(cookieCode),
      clickedAt: new Date().toISOString()
    }
  }

  return null
}

export function clearReferralContext() {
  localStorage.removeItem(REFERRAL_STORAGE_KEY)
  document.cookie = 'nocal_ref_code=; path=/; max-age=0; samesite=lax'
}
